export const LOAD_COVER_LOTS_FAIL = 'la/domain/coverLots/LOAD_FAIL';
export const LOAD_COVER_LOTS_REQUEST = 'la/domain/coverLots/LOAD_REQUEST';
export const LOAD_COVER_LOTS_SUCCESS = 'la/domain/coverLots/LOAD_SUCCESS';
